import React from "react";

import { useTranslation } from "react-i18next";

import { BackIcon } from "@routes/IconeSvg";

import FloatButton from "@components/buttons/FloatButton";

/**
 *
 * @param {Object} props
 * @param {() => void} props.onClick
 * @param {boolean=} props.hideText Par default false
 * @param {boolean=} props.wait Par default false
 * @param {string=} props.size
 * @returns
 */
function BackButton({ onClick, hideText = false, wait = false, size = "arh-w-10 arh-h-10" }) {
  const { t } = useTranslation("pages.employés.document");
  return (
    <div
      className={`${wait ? "arh-cursor-wait" : "arh-cursor-pointer"} ${size} arh-flex arh-items-center arh-gap-2`}
      aria-hidden="true"
      onClick={wait ? null : onClick}
    >
      <FloatButton
        size={size}
        color="arh-bg-transparent hover:arh-bg-gray-200 active:arh-bg-greyActive !arh-border-transparent"
      >
        <BackIcon />
      </FloatButton>

      {!hideText && (
        <span className="arh-font-poppins arh-text-base arh-font-normal arh-text-black mobile-768:arh-hidden">
          {t("Retour")}
        </span>
      )}
    </div>
  );
}

export default BackButton;
